export default __webpack_public_path__ + "static/media/Comptes_Supprimer.8f8ac83c.png";